import { WinDoPassConfigType } from "../generated/IpsCoreModel";

export default WinDoPassConfigType;